import { Icon, IconButton as ChakraIconButton, Tooltip } from '@chakra-ui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

export type BulkScalarEditAction = {
  type: 'clear';
};

export const bulkScalarClearAction: BulkScalarEditAction = { type: 'clear' };

type ScalarBulkClearButtonProps = {
  isDisabled?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  right?: number | string;
};

export function ScalarBulkClearButton({
  isDisabled,
  onClick,
  right = 2,
}: ScalarBulkClearButtonProps) {
  const { t } = useTranslation('ui');
  const label = t('table.bulkSelection.clear');

  return (
    <Tooltip label={label} hasArrow placement="top" openDelay={300}>
      {/* Parked with the Table round: an affordance inside a bulk cell
          editor's input, which converts with the cell editors. */}
      <ChakraIconButton
        aria-label={label}
        icon={<Icon as={XMarkIcon} boxSize={4} />}
        isDisabled={isDisabled}
        size="xs"
        variant="ghost"
        position="absolute"
        right={right}
        top="50%"
        transform="translateY(-50%)"
        zIndex={1}
        onMouseDown={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
        onClick={(event) => {
          event.stopPropagation();
          onClick(event);
        }}
      />
    </Tooltip>
  );
}
